export enum DirectionEnum {
    up = 1,
    down = -1
}

export const Direction = {
    up: DirectionEnum.up,
    down: DirectionEnum.down,
    /**
     * Сменить текущее направление
     * @param {DirectionEnum} dir
     * @returns {DirectionEnum.down | DirectionEnum.up}
     */
    toggle(dir: DirectionEnum) {
        return dir === DirectionEnum.up ? DirectionEnum.down : DirectionEnum.up;
    }
};

